"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _download = _interopRequireDefault(require("../../utils/download"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var saveTSV = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var url, _ref$files, files, fileName, _ref$options, options;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, _ref$files = _ref.files, files = _ref$files === void 0 ? [] : _ref$files, fileName = _ref.fileName, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options;
            return _context.abrupt("return", (0, _download["default"])(_objectSpread(_objectSpread({
              url: url,
              method: 'POST'
            }, options), {}, {
              params: _objectSpread({
                fileName: fileName,
                files: files.map(function (_ref3, i) {
                  var allColumns = _ref3.allColumns,
                      columns = _ref3.columns,
                      _ref3$exporterColumns = _ref3.exporterColumns,
                      exporterColumns = _ref3$exporterColumns === void 0 ? null : _ref3$exporterColumns,
                      file = _objectWithoutProperties(_ref3, ["allColumns", "columns", "exporterColumns"]);

                  return _objectSpread(_objectSpread({}, file), {}, {
                    columns: exporterColumns // if the component gave you custom columns to show
                    ? Object.values(exporterColumns.length > 0 // if they ask for any specific columns
                    ? // use them
                    exporterColumns.map(function (column) {
                      switch (_typeof(column)) {
                        // checking if the columns are customised
                        case 'object':
                          {
                            var extendedColumn = allColumns[column.fieldName];
                            return _objectSpread(_objectSpread({}, extendedColumn), column.displayName && {
                              displayName: typeof column.displayName === 'function' ? column.displayName(extendedColumn) : column.displayName
                            });
                          }
                        // or not

                        case 'string':
                        default:
                          return allColumns[column];
                      }
                    }) : allColumns // else, they're asking for all the columns
                    ) : columns.filter(function (column) {
                      return column.show;
                    }) // no custom columns, use admin's

                  });
                })
              }, options.params)
            })));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function saveTSV(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var exporterProcessor = function exporterProcessor(exporter, allowTSVExport, exportTSVText) {
  var exporterArray = Array.isArray(exporter) && exporter.filter(function (item) {
    return item;
  }).map(function (item) {
    return [item, item["function"]].some(function (fnName) {
      return fnName === 'saveTSV';
    }) || item.hasOwnProperty('fileName') && !item.hasOwnProperty('function') ? _objectSpread({
      exporterLabel: (item === null || item === void 0 ? void 0 : item.label) || exportTSVText,
      exporterFunction: saveTSV,
      exporterFileName: item === null || item === void 0 ? void 0 : item.fileName,
      exporterRequiresRowSelection: item === null || item === void 0 ? void 0 : item.requiresRowSelection
    }, (item === null || item === void 0 ? void 0 : item.columns) && Array.isArray(item.columns) && {
      exporterColumns: item === null || item === void 0 ? void 0 : item.columns
    }) : Object.entries(item).reduce(function (exporterItem, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];

      return _objectSpread(_objectSpread({}, exporterItem), {}, _defineProperty({}, "exporter".concat(key[0].toUpperCase()).concat(key.slice(1)), value));
    }, {});
  });
  var multipleExporters = exporterArray && exporter.length > 1; // this checks whether a single custom function has been provided
  // by itself, or as the single item in an array

  var resolveSingleExporter = function resolveSingleExporter(exporter, useDefaultTSV) {
    var _exporterArray$;

    switch (true) {
      case exporter instanceof Function:
        return exporter;

      case multipleExporters:
        return exporterArray;

      case exporterArray:
        return (_exporterArray$ = exporterArray[0]) === null || _exporterArray$ === void 0 ? void 0 : _exporterArray$.exporterFunction;

      case useDefaultTSV:
        return saveTSV;

      default:
        exporter && // log something to indicate this needs to be addressed
        console.log('The custom exporter(s) format provided was invalid');
    }
  };

  return {
    singleExporter: resolveSingleExporter(exporter, allowTSVExport),
    exporterArray: exporterArray,
    multipleExporters: multipleExporters
  };
};

var _default = exporterProcessor;
exports["default"] = _default;